module.exports = __webpack_public_path__ + "img/gold1.5948c06f.png";